import React from 'react';
import { Helmet } from 'react-helmet';
import HeroSection from '../components/HeroSection';
import GreatestCompanies from '../components/GreatestCompanies';
import GrowYourBusiness from '../components/GrowYourBusiness';
import ProductsSection from '../components/ProductsSection';
import WeAreAll from '../components/WeAreAll';
import TopServices from '../components/TopServices';
import UnleashPotential from '../components/UnleashPotential';
import WhiteMenuSection from '../components/WhiteMenuSection';
import Partners from '../components/Partners';

function Home() {
  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://marketingv8.co/" />
        <title>Marketing v8 - AI & Automation Agency</title>
        <meta name="description" content="Marketing v8 - AI-driven marketing automation agency. We help businesses grow with intelligent solutions." />
        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://marketingv8.co/" />
        <meta property="og:title" content="Marketing v8 - AI & Automation Agency" />
        <meta property="og:description" content="Marketing v8 - AI-driven marketing automation agency. We help businesses grow with intelligent solutions." />
        <meta property="og:image" content="https://marketingv8.co/logov8.png" />
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Marketing v8 - AI & Automation Agency" />
        <meta name="twitter:description" content="Marketing v8 - AI-driven marketing automation agency. We help businesses grow with intelligent solutions." />
        <meta name="twitter:image" content="https://marketingv8.co/logov8.png" />
        {/* JSON-LD */}
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Marketing v8",
          "url": "https://marketingv8.co",
          "logo": "https://marketingv8.co/logov8.png",
          "contactPoint": {
            "@type": "ContactPoint",
            "email": "office@marketingv8.co",
            "contactType": "customer service"
          },
          "sameAs": [
            "https://www.linkedin.com/company/marketing-v8"
          ]
        })}</script>
      </Helmet>
      <div className="App-main">
        <HeroSection />
        <GreatestCompanies />
      </div>

      <div className='App-max-width grow-your-buisness-archor'>
        <GrowYourBusiness />
      </div>

      <div className='App-main'>
        <ProductsSection />
        <WeAreAll />
        <TopServices />
      </div>
      <div className='App-max-width'>
        <WhiteMenuSection />
      </div>
      <div className='App-main'>
        <UnleashPotential />
        <Partners />
      </div>
    </>
  );
}

export default Home;
